<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.screenResolution }}</div>
      <div class="col-sm-3">{{ result.text }}</div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="alert alert-danger" v-show="result.value === 'failed'">{{ i18n.results.screenResolution }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckerStatus from './CheckerStatus'

const checkerName = 'screen-resolution'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var width = window.screen.width
    var height = window.screen.height
    this.result.text = width + ' x ' + height
    this.result.value = (width < 1024 || height < 730) ? 'failed' : 'passed'
    this.$emit('completed', {name: checkerName, result: this.result.text})
  }
}
</script>



// WEBPACK FOOTER //
// ScreenResolution.vue?765b46dc